import React, { useState, useEffect } from "react";
import { Settings } from "lucide-react";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const has = localStorage.getItem("acar_cookie_consent");
    if (!has) setVisible(true);
  }, []);

  const handle = (val) => {
    localStorage.setItem("acar_cookie_consent", val);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60] bg-white rounded-lg p-5 border border-slate-200">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-[#1c4d9c]/10 text-[#1c4d9c] flex items-center justify-center shrink-0">
          <Settings className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <p className="text-[13px] text-slate-700 leading-relaxed">
            İnternet sitemizden en verimli şekilde faydalanabilmeniz ve
            kullanıcı deneyiminizi geliştirebilmek için Çerez kullanıyoruz.{" "}
            <a href="#" className="text-[#1c4d9c] font-medium hover:underline">
              devamı...
            </a>
          </p>
          <div className="flex gap-2 mt-4">
            <button
              onClick={() => handle("accept")}
              className="px-4 py-2 text-[13px] rounded-md bg-[#1c4d9c] hover:bg-[#143a78] text-white font-medium transition"
            >
              Kabul Et
            </button>
            <button
              onClick={() => handle("reject")}
              className="px-4 py-2 text-[13px] rounded-md bg-slate-100 hover:bg-slate-200 text-slate-700 font-medium transition"
            >
              Reddet
            </button>
            <button
              onClick={() => handle("settings")}
              className="px-4 py-2 text-[13px] rounded-md bg-slate-100 hover:bg-slate-200 text-slate-700 font-medium transition"
            >
              Ayarlar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
